import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { getUrlParams } from "../apiService/timespam";
import "./Theme.css";
import "./PSQIDetails.css";

const PSQI_COMPONENTS = [
  { key: "c1", label: "Subjective Sleep Quality", paramKey: "componentScore1" },
  { key: "c2", label: "Sleep Latency", paramKey: "componentScore2" },
  { key: "c3", label: "Sleep Duration", paramKey: "componentScore3" },
  { key: "c4", label: "Habitual Sleep Efficiency", paramKey: "componentScore4" },
  { key: "c5", label: "Sleep Disturbances", paramKey: "componentScore5" },
  { key: "c6", label: "Use of Sleep Medication", paramKey: "componentScore6" },
  { key: "c7", label: "Daytime Dysfunction", paramKey: "componentScore7" },
];

const PSQIDetails = () => {
  const { t } = useTranslation();
  const { theme, lang } = getUrlParams();
  const urlParams = new URLSearchParams(window.location.search);
  const psqiScore = urlParams.get("psqiScore") || "0";

  useEffect(() => {
    document.documentElement.className = theme === "dark" ? "dark" : "";
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
  }, [theme, lang]);

  return (
    <section className="psqi-details-page">
      <div className="psqi-details-score-card">
        <h2 className="psqi-details-score-label">{t("psqiDetails.totalScore")}</h2>
        <h1 className="psqi-details-score-value">{psqiScore}</h1>
        <p className="psqi-details-score-note">{t("psqiDetails.note")}</p>
      </div>
      <div className="psqi-details-components">
        {PSQI_COMPONENTS.map(({ key, label, paramKey }) => (
          <div key={key} className="psqi-details-row">
            <span className="psqi-details-comp-label">{label}</span>
            <span className="psqi-details-comp-score">{urlParams.get(paramKey) || "0"}</span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default PSQIDetails;
